import React, { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { FormShell, FormField, FormFooter } from '../../../../../../generic/ui/FormLayout'
import IconTextField from '../../../../../../generic/ui/Input/IconTextField'
import { AccentButton } from '../../../../../../generic/ui/Button/AccentButton'
import PackageBoxIcon from '../../../../../../generic/icons/IconLib/PackageBoxIcon'
import ProductImage from '../../../queries/TeudotDetails/Components/ProductImage'
import { IBalanceModalProps } from '../types/productLocation'

const EditBalanceModal = ({ item, onSave }: IBalanceModalProps) => {
  const [t] = useTranslation(['knisa', 'buttons'])
  // Строкой, чтобы пустое поле не превращалось в 0
  const [value, setValue] = useState<string>(String(item.BalanceAmount))
  const balanceAmount = Number(value)
  // Остаток может быть отрицательным — проверяем только, что это целое и что его поменяли
  const canSave = value.trim() !== '' && Number.isInteger(balanceAmount) && balanceAmount !== item.BalanceAmount

  return (
    <FormShell>
      <ImageSlot>
        <ProductImage id={item.GeneralProductID || 0} />
      </ImageSlot>
      <FormField label={t('knisa:knisa_create_modal_product_balance')} fullWidth>
        {/* без inputMode='numeric': на iOS такая клавиатура не даёт ввести минус */}
        <IconTextField
          type='number'
          value={value}
          onChange={(e) => setValue(e.target.value)}
          leadingIcon={<PackageBoxIcon />}
        />
      </FormField>
      <FormFooter>
        <AccentButton
          type='button'
          onClick={() => onSave(balanceAmount)}
          disabled={!canSave}
          fullWidth={false}
        >
          {t('buttons:save')}
        </AccentButton>
      </FormFooter>
    </FormShell>
  )
}

export default EditBalanceModal

const ImageSlot = styled.div`
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 7.5rem;
  height: 7.5rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: ${({ theme }) => theme.radii.md};
  }
`
